<template>
  <section class="portal">
    <div class="portal__inner">

      <!-- Left: copy + CTA -->
      <div class="portal__content">
        <h3 class="portal__title">{{ $t('home.portalTitle') }}</h3>

        <p class="portal__subtitle">{{ $t('home.portalSubtitle') }}</p>

        <a
          href="https://raqamlitalim.trm.uz/"
          target="_blank"
          rel="noopener"
          class="portal__cta"
        >
          {{ $t('common.goToSite') }}
          <img class="portal__cta-icon" src="@/assets/img/logos/arrow-up-right.png" alt="" />
        </a>
      </div>

      <!-- Right: device mockup (links to the portal) -->
      <div class="portal__device">
        <a
          href="https://raqamlitalim.trm.uz/"
          target="_blank"
          rel="noopener"
          :aria-label="$t('home.portalTitle')"
          style="display:block"
        >
          <img ref="laptop" src="@/assets/img/images/laptop.png" :alt="$t('home.portalTitle')" />
        </a>
      </div>

    </div>
  </section>
</template>

<script>
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'RaqamliPortal',

  // ── Laptop slide-in from the right ──────────────────────────────────────────
  // Scrubbed to scroll: the laptop slides in from off-screen right as the section
  // enters, and slides back out to the right when scrolling up. Desktop + motion-OK
  // only. TO REVERT: delete this mounted/beforeUnmount block, the gsap imports,
  // and the ref="laptop" on the <img>.
  mounted() {
    const mm = window.matchMedia
    const reduce = mm && mm('(prefers-reduced-motion: reduce)').matches
    const desktop = mm && mm('(min-width: 1025px)').matches   // device is absolute only here
    if (reduce || !desktop) return
    const el = this.$refs.laptop
    if (!el) return
    this._slide = gsap.fromTo(
      el,
      { xPercent: 130, opacity: 0 },
      {
        xPercent: 0,
        opacity: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: '.portal',
          start: 'top 95%',   // begins sliding in as the section appears
          end: 'top 45%',     // fully in place once the section is well in view
          scrub: 1.2          // higher = eases toward the scroll position (smoother)
        }
      }
    )
  },
  beforeUnmount() {
    if (this._slide) {
      if (this._slide.scrollTrigger) this._slide.scrollTrigger.kill()
      this._slide.kill()
      this._slide = null
    }
  }
};
</script>

<style lang="scss">
@import '../../styles/components/05raqamli_portal/raqamli_portal.scss';
</style>
